// extracted by mini-css-extract-plugin
export default {"wrapper":"Item__wrapper--1R_Nk","image":"Item__image--3yllM","label":"Item__label--1boXB"};